export interface StepSection {
  label: string;
  start: number;
  count: number;
}

/** Consecutive steps that share a name form one section. */
export const groupStepsIntoSections = (steps: string[]): StepSection[] =>
  steps.reduce<StepSection[]>((sections, rawLabel, index) => {
    const label = (rawLabel || '').trim();
    const last = sections[sections.length - 1];
    if (last && last.label === label) {
      last.count += 1;
    } else {
      sections.push({ label, start: index, count: 1 });
    }
    return sections;
  }, []);

/** How far through `section` the visitor is, 0–100. */
export const sectionFill = (section: StepSection, activeStep: number): number => {
  if (activeStep >= section.start + section.count) return 100;
  if (activeStep < section.start) return 0;
  return ((activeStep - section.start + 1) / section.count) * 100;
};
